import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { getImage } from 'gatsby-plugin-image'
import StructuredData from './StructuredData'
import { optimizelyExperimentID } from '../helpers/constants'
import defaultOpenGraphImage from '../assets/images/avantbanking-open-graph-01.png'

function CustomSEO({ metaDataCustom }) {
  const optimizelyScript = `https://cdn.optimizely.com/js/${optimizelyExperimentID}.js`
  const defaultTitle = 'Apply for a Loan Online, Check your Loan Options | Avant'
  const defaultDescription =
    'Change the way you borrow with loans through Avant. Loans ranging from $2,000-$35,000. APR ranges from 9.95% to 35.99%. No Prepayment fees. We have a simple online loan application. Checking your loan options won’t impact your credit score...'
  let canonical
  if (metaDataCustom.canonicalUrl) {
    canonical = <link rel="canonical" href={metaDataCustom.canonicalUrl} />
  } else if (metaDataCustom.slug === 'odsLoan') {
    canonical = <link rel="canonical" href="https://www.avant.com/personal-loans/" />
  } else if (!metaDataCustom.metaRobots?.join(',')) {
    canonical = (
      <link rel="canonical" href={typeof window !== 'undefined' ? window.location.href : null} />
    )
  } else {
    canonical = null
  }

  const finalDescription = metaDataCustom.metaDescription || defaultDescription

  const openGraph = metaDataCustom.openGraph || {}

  const meta = [
    { name: 'description', content: finalDescription },
    { name: 'keywords', content: '' },
    { name: 'robots', content: metaDataCustom.metaRobots?.join(',') || '' },
    { property: 'og:title', content: openGraph?.title || metaDataCustom.pageTitle },
    { property: 'og:description', content: openGraph?.description || finalDescription },
    { property: 'og:image', content: getImage(openGraph?.image) || defaultOpenGraphImage },
    { property: 'og:image:width', content: '1200' },
    { property: 'og:image:height', content: '630' },
    { property: 'og:type', content: 'website' },
    { property: 'og:site_name', content: 'Avant' },
    { property: 'og:locale', content: 'en_US' }
  ]

  return (
    <Helmet title={metaDataCustom.pageTitle || defaultTitle} meta={meta}>
      <script src={optimizelyScript} />
      {canonical}
      <html lang="en" />
      {typeof window !== 'undefined' && window.location.pathname === '/credit-card/' ? (
        <script type="application/ld+json">{JSON.stringify(StructuredData.creditCard)}</script>
      ) : null}
    </Helmet>
  )
}
CustomSEO.propTypes = {
  metaDataCustom: PropTypes.object.isRequired
}

export default CustomSEO
